const Weight = {
  extra_bolder: 700,
  bolder: 600,
  semi_bolder: 500,
  regular: 400,
}
export default Weight
